// extracted by mini-css-extract-plugin
export default {"container":"ApplePayTitle_container__B-OrO","applepayIcon":"ApplePayTitle_applepayIcon__B4-kq"};